import { v4 } from 'uuid';

type UUIDBrand = string;
export type UUID<T extends UUIDBrand> = { __brand: T } & string;
export const getUUID = <T extends UUIDBrand>(_brand?: T): UUID<T> => v4() as UUID<T>;
